import { defineProductDimensions, mrpaPricingVersionDimension, mrpaSelectedDimension } from '@orus.eu/dimensions'

import { mrpaProductVersionDimension } from './mrpa-activity-vocabulary.ts'
import { mrpaQuoteDimension } from './mrpa-quote-dimension.ts'

export * from './mrpa-activity-vocabulary.ts'
export * from './mrpa-dimensions.ts'
export * from './mrpa-subscription-ui.ts'
export * from './mrpa-ui-elements.ts'

export const mrpaDimensionsModule = defineProductDimensions({
  product: 'mrpa',
  family: 'mrp',
  selectionDimension: mrpaSelectedDimension,
  productVersionDimension: mrpaProductVersionDimension,
  pricingVersionDimension: mrpaPricingVersionDimension,
  quoteV3Dimension: mrpaQuoteDimension,
})
